import { useRef } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { SCENTS } from "@/config";

export const Gallery = () => {
  const trackRef = useRef(null);
  const nudge = (dir) => trackRef.current?.scrollBy({ left: dir * 340, behavior: "smooth" });

  return (
    <section id="gallery" className="py-16 md:py-20">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <Reveal className="flex items-end justify-between gap-6 mb-8">
          <div>
            <span className="text-xs uppercase tracking-[0.25em] font-semibold text-brandTerracotta">Up Close</span>
            <h2 className="font-serif text-3xl sm:text-4xl font-bold mt-2">Every blend, in the light</h2>
          </div>
          <div className="hidden sm:flex gap-2">
            <button
              data-testid="gallery-left-btn"
              onClick={() => nudge(-1)}
              aria-label="Scroll gallery left"
              className="w-11 h-11 rounded-full border border-brandDarkSlate/20 flex items-center justify-center hover:bg-brandSand transition-colors"
            >
              <ChevronLeft className="w-5 h-5" />
            </button>
            <button
              data-testid="gallery-right-btn"
              onClick={() => nudge(1)}
              aria-label="Scroll gallery right"
              className="w-11 h-11 rounded-full border border-brandDarkSlate/20 flex items-center justify-center hover:bg-brandSand transition-colors"
            >
              <ChevronRight className="w-5 h-5" />
            </button>
          </div>
        </Reveal>
      </div>
      <Reveal delay={0.1}>
        <div
          ref={trackRef}
          data-testid="gallery-track"
          className="flex gap-5 overflow-x-auto snap-x snap-mandatory px-4 sm:px-6 lg:px-[max(1.5rem,calc((100vw-72rem)/2+1.5rem))] pb-4 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
        >
          {SCENTS.map((s) => (
            <figure key={s.id} className="snap-center shrink-0 w-72 sm:w-80">
              <div className="aspect-[4/5] rounded-t-[8rem] rounded-b-2xl overflow-hidden border border-brandSand shadow-md shadow-brandTerracotta/10">
                <img
                  data-testid={`gallery-img-${s.id}`}
                  src={s.img}
                  alt={`${s.name} — Enchanted Glim candle`}
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-700 hover:scale-105"
                />
              </div>
              <figcaption className="mt-3 text-center">
                <span className="font-serif font-bold text-lg">{s.name}</span>
                <span className="block text-xs text-brandDarkSlate/60 mt-0.5">{s.benefit}</span>
              </figcaption>
            </figure>
          ))}
        </div>
      </Reveal>
    </section>
  );
};
